<template>
  <div style="text-align: left">
    <TreeBlock
      class="pb-2"
      @change="onChange($event)"
      @copy="onCopy($event, index)"
      @rename="onRename($event)"
      @remove="onRemove($event)"
      @create="onCreate($event)"
      :value="data"
    >
    </TreeBlock>

    <v-textarea
      outlined
      v-model="dataText"
      :label="model.title"
      :error-messages="error"
      :hide-details="config.hideDetails || false"
      :readonly="readonly"
      :disabled="disabled"
      :dense="model.opts && model.opts.includes('dense')"
      :auto-grow="model.opts && model.opts.includes('auto-grow')"
      :placeholder="model.placeholder"
      :persistent-placeholder="!!model.placeholder || false"
      :rows="model.rows || 5"
      @input1="$emit('input', $event)"
      prepend-inner-icon="mdi-code-tags"
      @click:prepend-inner="dialog = true"
    >
    </v-textarea>
    <v-dialog v-if="model.code" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense flat color="primary" dark>
          <v-btn icon @click="closeEditor">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Редактор кода</v-toolbar-title>
          <v-spacer />
          <v-btn text @click="applyChanges">Сохранить</v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="flex: 1 1 auto; display: flex">
          <a-input-base-monaco-editor v-if="dialog" v-model="tempValue" :language="model.codeLang" ref="editor" style="flex: 1 1 auto; width: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {
    TreeBlock: () => import("@/views/tree/treeBlock"),
  },
  props: {
    value: [String, Number, Object, Array],
    values: Object,
    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {} },
  },
  data() {
    return {
      dialog: false,
      tempValue: "",
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.tempValue = this.dataText;
      }
    },
  },
  computed: {
    isFolder: function () {
      if (this.data === null) return false;
      return Array.isArray(this.data) || typeof this.el === "object";
    },
    data: {
      get() {
        return this.value;
      },
      set(v) {
        let res = v;
        console.log("set", v);
        this.$emit("input", res);
      },
    },
    dataText: {
      get() {
        return JSON.stringify(this.value);
      },
      set(v) {
        let res = v;
        try {
          console.log("try convert json");
          res = JSON.parse(v);
        } catch (error) {
          try {
            console.log("error", error);
            console.log("try eval");
            res = eval("(" + v + ")");
          } catch (error) {
            console.log("error", error);
          }
        }

        this.$emit("input", res);
      },
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
  },
  methods: {
    closeEditor() {
      this.dialog = false;
    },
    applyChanges() {
      const v = this.$refs.editor.editor.getValue();
      this.$emit("input", v);
      this.dialog = false;
    },
    onCopy(e) {
      console.log("onCopy:", e);
      //this.data[e.i] = e.v;
    },
    onRename(e) {
      console.log("onRename:", e);
      //this.data[e.i] = e.v;
    },
    onChange(e) {
      console.log("onChange:", e);
      if (e.i == -1) {
        this.data = e.v;
        return;
      }
      this.data[e.i] = e.v;
    },
    onCreate(e) {
      console.log("onCreate:", e);
      this.data[e.i] = e.v;

      // this.data[e.i] = e.v;
    },
    onRemove(e) {
      console.log("onRemove:", e);
      this.data[e.i] = e.v;
    },
  },
};
</script>
